
import { AssetMaintenance } from './asset-maintenance.model';
import { ComposedRowsEntityDecorator, EntityDecorator } from '@scisys-uim/uim-common';


export abstract class AssetMaintenanceRowsEntityDecoratorBase<G> extends ComposedRowsEntityDecorator<AssetMaintenance, number, G> {
  constructor(rowTypeDecorator: EntityDecorator<AssetMaintenance, number>, 
    groupTypeDecorator: EntityDecorator<any, G>) {
    super(rowTypeDecorator, groupTypeDecorator);
  }
}



